module.exports = __webpack_public_path__ + "img/image-3.21b68632.webp";